<template>
  <div class="full-wrapper pannel">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <!-- <w-operation-state-info :obj-name="selectedNode.label" :state-data="operationStateData"></w-operation-state-info> -->
        <el-row>
          <div class="row">
            <el-col :md="12" :lg="12">
              <w-perf-widget :show-change-btn="false">
                <span slot="perfHeader">구성 정보</span>
                <div slot="perfBody">
                  <el-col :md="24" :lg="12">
                    <table class="list-none-border">
                      <tr>
                        <th>DB명</th>
                        <td>{{ configInfoData.objName }}</td>
                      </tr>
                      <tr>
                        <th>DB종류(버전)</th>
                        <td>{{ configInfoData.objtypeId }}({{configInfoData.objProductId }})</td>
                      </tr>
                      <tr>
                        <th>IP</th>
                        <td>{{ configInfoData.dbmsIpaddress }}</td>
                      </tr>
                    </table>
                  </el-col>
                  <el-col :md="24" :lg="12">
                    <table class="list-none-border">
                      <tr>
                        <th>포트번호</th>
                        <td>{{ configInfoData.dbmsPort }}</td>
                      </tr>
                      <tr>
                        <th>서비스명</th>
                        <td>{{ configInfoData.dbmsAlias }}</td>
                      </tr>
                      <tr>
                        <th>관리자 (정/부)</th>
                        <td>{{ configInfoData.majorLabel }}</td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>{{ configInfoData.minorLabel }}</td>
                      </tr>
                      <tr>
                        <th>구동 시간</th>
                        <td>{{ configInfoData.dbmsUptimeLabel }}</td>
                      </tr>
                    </table>
                  </el-col>
                </div>
                <div slot="perfFooter">
                  <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }}</span>
                </div>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('PROC', ...arguments)" :show-change-btn="false" :eventlevel="procData.eventlevel">
                <span slot="perfHeader">데몬 프로세스</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="procViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in procData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="procData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="procViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in procData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in procData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(procData.backBody, data) }" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('SESSION', ...arguments)" :show-change-btn="false" :eventlevel="sessionData.eventlevel">
                <span slot="perfHeader">Session</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="sessionViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in sessionData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="sessionData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="legend list" v-if="sessionViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in sessionData.frontFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in sessionData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(sessionData.backBody, data) }" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('LOCK', ...arguments)" :show-change-btn="false" :eventlevel="lockData.eventlevel">
                <span slot="perfHeader">Lock</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="lockViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in lockData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="lockData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="legend list" v-if="lockViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in lockData.frontFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in lockData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(lockData.backBody, data) }" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('TABLESPACE', ...arguments)" :show-change-btn="true" :eventlevel="tablespaceData.eventlevel">
                <span slot="perfHeader">공간사용 TOP 5</span>
                <!-- BODY -->
                <el-row style="height:100%;" v-if="tablespaceViewIndex === 0" slot="perfBody">
                  <el-table-wrapper style="height:100%;" fit-height :data="tablespaceData.frontBody" :columns="tableSpaceTableColumns" :show-custom-header="false" :show-search-tool="false" :pagination="false">
                    <template slot-scope="scope" slot="status-slot">
                      <i v-if="scope.row.statusAlive !== null" :class="`${ scope.row.statusAlive === '1' ? 'fas fa-circle state-normal' : 'fas fa-circle text-mini state-abnormal'}`"></i>
                      <el-tooltip v-else effect="dark" content="자원 미수집" placement="top"><span> - </span></el-tooltip>
                    </template>
                    <template slot-scope="scope" slot="userate-slot">
                      <span>{{ convertValuByUnit(scope.row['TABLESPACE/DB_TABLESPACE_USERATE'], '%', true, true, false) }}</span>
                    </template>
                    <template slot-scope="scope" slot="total-slot">
                      <span>{{ convertValuByUnit(scope.row['TABLESPACE/DB_TABLESPACE_TOTSIZE'], 'MB', true, true, true) }}</span>
                    </template>
                    <template slot-scope="scope" slot="used-slot">
                      <span>{{ convertValuByUnit(scope.row['TABLESPACE/DB_TABLESPACE_USEDSIZE'], 'MB', true, true, true) }}</span>
                    </template>
                    <template slot-scope="scope" slot="avail-slot">
                      <span>{{ convertValuByUnit(scope.row['TABLESPACE/DB_TABLESPACE_AVSIZE'], 'MB', true, true, true) }}</span>
                    </template>
                  </el-table-wrapper>
                </el-row>
                <w-summary-line-chart v-else slot="perfBody" :series="tablespaceData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="legend list" v-if="tablespaceViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in tablespaceData.frontFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in tablespaceData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(tablespaceData.backBody, data) }" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('MEM', ...arguments)" :show-change-btn="false" :eventlevel="memData.eventlevel">
                <span slot="perfHeader">메모리</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="memViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in memData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="memData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="multi" v-if="memViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-h-info v-for="data in memData.frontFooter"  style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in memData.backFooter" :key="data.widgetKey" :widget-info="data"  :legend-info="{ isLegend: true, index: findFooterIndex(memData.backBody, data) }" />
                </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('HOST', ...arguments)" :show-change-btn="false" :eventlevel="hostData.eventlevel">
                <span slot="perfHeader">Host 성능</span>
                <!-- BODY -->
                <ul class="event-info-list" v-if="hostViewIndex === 0" slot="perfBody">
                  <w-perf-body-info v-for="data in hostData.frontBody" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <w-summary-line-chart v-else slot="perfBody" :series="hostData.backBody"></w-summary-line-chart>
                <!-- FOOTER -->
                <ul class="legend list" v-if="hostViewIndex === 0" slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in hostData.frontFooter" :key="data.widgetKey" :widget-info="data" />
                </ul>
                <ul class="legend list" v-else slot="perfFooter">
                  <w-perf-footer-v-info v-for="data in hostData.backFooter" :key="data.widgetKey" :widget-info="data"  :legend-info="{ isLegend: true, index: findFooterIndex(hostData.backBody, data) }" />
                </ul>
              </w-perf-widget>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import { calcUptime, getIntervalDatetimeParams } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { DATABASE } from '@/constants/summary';
import databaseApi from '@/api/performance/database/database-info';
import summaryApi from '@/api/performance/summary/summary-info';
import WPerfWidget from '../components/PerfWidget';
import WPerfBodyInfo from '../components/PerfBodyInfo';
import WPerfFooterVInfo from '../components/PerfFooterVInfo';
import WPerfFooterHInfo from '../components/PerfFooterHInfo';
import WOperationStateInfo from '../components/OperationStateInfo';
import WSummaryLineChart from '../components/SummaryLineChart';
import WEventInfoWidget from '../components/EventInfoWidget';

export default {
  name: 'WPerformanceDatabaseSummary',
  mixins: [ScrollbarMixin],
  components: {
    WPerfWidget,
    WPerfBodyInfo,
    WPerfFooterVInfo,
    WPerfFooterHInfo,
    WOperationStateInfo,
    WSummaryLineChart,
    WEventInfoWidget,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      params: {
        managetypeId: 'DBMS',
      },
      operationStateParams: { rsctypeId: '', rscId: '', rscKey: '' },
      configInfoData: {},
      eventInfoData: {},
      procViewIndex: 1,
      sessionViewIndex: 1,
      lockViewIndex: 1,
      memViewIndex: 1,
      tablespaceViewIndex: 0,
      hostViewIndex: 1,
      procData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      sessionData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      lockData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      memData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      tablespaceData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      hostData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      tableSpaceTableColumns: [
        {
          prop: 'rscKeyName',
          label: '테이블공간명',
          align: 'left',
          sortable: false,
          showOverflowTooltip: true,
        },
        {
          prop: 'TABLESPACE/DB_TABLESPACE_USERATE',
          label: '사용률',
          width: 100,
          align: 'right',
          scopedSlot: 'userate-slot',
          sortable: false,
        },
        {
          prop: 'TABLESPACE/DB_TABLESPACE_TOTSIZE',
          label: '전체(Byte)',
          width: 100,
          align: 'right',
          scopedSlot: 'total-slot',
          sortable: false,
        },
        {
          prop: 'TABLESPACE/DB_TABLESPACE_USEDSIZE',
          label: '사용량(Byte)',
          width: 100,
          align: 'right',
          scopedSlot: 'used-slot',
          sortable: false,
        },
        {
          prop: 'TABLESPACE/DB_TABLESPACE_AVSIZE',
          label: '가용량(Byte)',
          width: 100,
          align: 'right',
          scopedSlot: 'avail-slot',
          sortable: false,
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    getIntervalDatetimeParams,
    loadData() {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          objtypeId: this.selectedNode.obj.objtypeId,
          startDatetime,
        });
        this.loadConfInfoView();
        this.loadEventInfo();

        const widgetKeyList = ['PROC', 'SESSION', 'LOCK', 'MEM', 'TABLESPACE', 'HOST'];
        widgetKeyList.forEach((widgetKey) => {
          const widgetKeyLower = widgetKey.toLowerCase();
          this.changeWidgetView(widgetKey, this[`${widgetKeyLower}ViewIndex`]);
        });
      }
    },
    /**
     * 구성 정보 load
     * @author jeee12
     */
    loadConfInfoView() {
      databaseApi.getDatabaseConfigurationInfo({
        objId: this.selectedNode.obj.objId,
      }).then((response) => {
        if (response.data.success) {
          const configInfo = response.data.data;
          let majorLabel = EMPTY_TEXT;
          let minorLabel = EMPTY_TEXT;

          if (configInfo.majorName) {
            majorLabel = configInfo.majorDepartment ? `[${configInfo.majorDepartment}]${configInfo.majorName}` : `[${EMPTY_TEXT}]${configInfo.majorName}`;
          }
          if (configInfo.minorName) {
            minorLabel = configInfo.minorDepartment ? `[${configInfo.minorDepartment}]${configInfo.minorName}` : `[${EMPTY_TEXT}]${configInfo.minorName}`;
          }
          configInfo.majorLabel = majorLabel;
          configInfo.minorLabel = minorLabel;
          configInfo.checkDatetimeLabel = !isNil(configInfo.checkDatetime) ? moment(configInfo.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : EMPTY_TEXT;
          configInfo.dbmsUptimeLabel = configInfo.dbmsUptime ? calcUptime(new Date(configInfo.dbmsUptime), new Date()) : '-';
          this.configInfoData = configInfo;
        }
      });
    },
    /**
     * 이벤트 정보 조회
     * @author jeee12
     */
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      summaryApi.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
    changeWidgetView(widgetKey, viewIndex) {
      const widgetKeyLower = widgetKey.toLowerCase();
      this[`${widgetKeyLower}ViewIndex`] = viewIndex;
      // 데이터 로드
      if (this[`${widgetKeyLower}ViewIndex`] === 0) {
        // 전면 데이터 로드 함수 호출
        this.loadFrontData(widgetKey);
      } else {
        // 후면 데이터 로드 함수 호출
        this.loadBackData(widgetKey);
      }
    },
    loadFrontData(widgetKey) {
      const widgetParam = clone(this.params);
      const rscParam = DATABASE.FRONT[widgetKey][widgetParam.objtypeId];
      let rscInfoList = [];
      if (!isEmpty(rscParam)) {
        rscInfoList = rscParam;
      } else {
        rscInfoList = DATABASE.FRONT[widgetKey].TOTAL;
      }

      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList,
        rscKey: '_', // 현재 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });

      databaseApi.getDatabaseSummaryRscRsltList(widgetParam).then((response) => {
        if (response.data.success) {
          if (isEqual(widgetKey, 'TABLESPACE')) {
            let body = response.data.data.body;
            if (!isNil(body)) {
              const total = body.filter((item) => isEqual(item.rscKey, '_'))[0];
              body.splice(body.indexOf(total), 1);
              const nullDatas = body.filter((item) => isNil(item['TABLESPACE/DB_TABLESPACE_USERATE']));
              if (!isNil(nullDatas)) {
                nullDatas.forEach((nullData) => {
                  body.splice(body.indexOf(nullData), 1);
                });
              }
              body = sortBy(body, ['TABLESPACE/DB_TABLESPACE_USERATE']).reverse();
              body = body.slice(0, 5);
            }
            this[widgetKey.toLowerCase().concat('Data')].frontBody = body;
          } else {
            this[widgetKey.toLowerCase().concat('Data')].frontBody = response.data.data.body;
          }
          this[widgetKey.toLowerCase().concat('Data')].frontFooter = response.data.data.footer;
          this[widgetKey.toLowerCase().concat('Data')].eventlevel = response.data.data.eventlevel;
        }
      });
    },
    loadBackData(widgetKey) {
      const widgetParam = clone(this.params);
      const rscParam = DATABASE.BACK[widgetKey][widgetParam.objtypeId];
      let rscInfoList = [];
      if (!isEmpty(rscParam)) {
        rscInfoList = rscParam;
      } else {
        rscInfoList = DATABASE.BACK[widgetKey].TOTAL;
      }
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList,
        rscKey: '_', // 현재 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });

      databaseApi.getDatabaseSummaryRscRsltBackList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].backBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].backFooter = response.data.data.footer;
          this[widgetKey.toLowerCase().concat('Data')].eventlevel = response.data.data.eventlevel;
        }
      });
    },
    /**
     * 후면 body 데이터 중 footer 데이터의 인덱스 검색
     * @author jeee12
     * @param  {[type]} backBodySeries [description]
     * @param  {[type]} footer         [description]
     * @return {[type]}                [description]
     */
    findFooterIndex(backBodySeries, footer) {
      return backBodySeries.findIndex((e) => {
        if (footer.rsckey) {
          return e.rscInfo.rscKeyName === footer.rscKeyName;
        } else if (e.rscInfo) {
          return e.rscInfo.rsctypeId === footer.rsctypeId && e.rscInfo.rscId === footer.rscId;
        }
        return null;
      });
    },
    convertValuByUnit,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/database/index.vue